export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  organizationName: string;
  role?: string; // Added to track user role from JWT
  createdAt: string;
  /** Clave del icono de avatar elegido; sin ella la UI cae a la inicial. */
  avatarIcon?: string | null;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  organizationId: string;
}

export interface RegisterWithOrganizationRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  organizationName: string;
  restaurantName: string;
  recaptchaToken: string;
  acceptTermsAndConditions: boolean;
  acceptPrivacyNotice: boolean;
  termsVersion: string;
  privacyVersion: string;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  user: User;
  hasClosedOtherSessions?: boolean;
  closedSessionsCount?: number;
  // Trial info
  trialEndDate?: string;
  isTrialExpired?: boolean;
  maxUsers?: number;
  plan?: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface SendVerificationCodeRequest {
  email: string;
  recaptchaToken: string;
}

export interface VerifyCodeRequest {
  email: string;
  code: string;
}

export interface VerifyCodeResponse {
  verified: boolean;
  message: string;
}
/** Credencial de Google Identity Services: el ID token tal cual lo entrega el navegador. */
export interface GoogleLoginRequest {
  idToken: string;
  restaurantId?: string;
  deviceType?: string;
}

export interface GoogleRegisterWithOrganizationRequest {
  idToken: string;
  recaptchaToken: string;
  organizationName: string;
  restaurantName: string;
  acceptTermsAndConditions: boolean;
  acceptPrivacyNotice: boolean;
  termsVersion: string;
  privacyVersion: string;
}

/** Perfil que devuelve el backend cuando el correo de Google todavía no tiene cuenta. */
export interface GoogleProfile {
  email: string;
  firstName: string;
  lastName: string;
  picture?: string | null;
}

/**
 * Códigos de error del backend (AuthErrorCodes.cs). Se ramifica por el código y no por el
 * texto del mensaje: el mensaje es para leerse y puede cambiar de redacción sin aviso.
 */
export const AUTH_ERROR_CODES = {
  googleNoAccount: 'GOOGLE_NO_ACCOUNT',
  accountExists: 'ACCOUNT_EXISTS',
  googleInvalidToken: 'GOOGLE_INVALID_TOKEN',
  googleNotConfigured: 'GOOGLE_NOT_CONFIGURED',
} as const;
